import { render, staticRenderFns } from "./BulkDossierDownloadButton.vue?vue&type=template&id=56610e42&scoped=true"
import script from "./BulkDossierDownloadButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./BulkDossierDownloadButton.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56610e42",
  null
  
)

export default component.exports